#import "../fragments/meeting-fragment.graphql"

mutation UpdateMeeting($input: MeetingUpdateInput!) {
    meetingUpdate(input: $input) {
        meeting {
            ...MeetingFragment
        }
    }
}
